// extracted by mini-css-extract-plugin
export default {"message":"InfoPopup_message__0kSS-","container":"InfoPopup_container__B1EES","cancel_icon":"InfoPopup_cancel_icon__GDg-X"};